import React from "react";
import { View, Grid, useTheme, Heading, Text } from "@aws-amplify/ui-react";
import GeneralButton from "./GeneralButton";
import "./GeneralButton.css";

export const ProductSuccess = () => {
  const { tokens } = useTheme();

  return (
    <div
      style={{
        fontFamily: "Poppins, Arial, sans-serif",
        background: "transparent", // Transparent background
        minHeight: "100vh", // Full viewport height
        display: "flex",
        justifyContent: "center", // Horizontally center the card
        alignItems: "center", // Vertically center the card
        padding: "2em", // Add padding for smaller screens
      }}
    >
      <Grid
        templateColumns="1fr"
        gap="2em"
        style={{
          maxWidth: "800px",
          width: "100%",
          backgroundColor: "#ffffff", // Card background remains white for contrast
          borderRadius: "16px",
          boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
          padding: "2em",
        }}
      >
        {/* Section: Header */}
        <View style={{ textAlign: "left", paddingBottom: "1em" }}>
          <Heading
            level={2}
            style={{
              fontSize: "2.5em",
              fontWeight: "600",
              color: tokens.colors.font.primary,
              marginBottom: ".5em", // Add spacing below the heading
            }}
          >
            Prodotto aggiunto con successo!
          </Heading>
          <Text
            style={{
              fontSize: "1.1em",
              color: tokens.colors.font.secondary,
              lineHeight: "1.6",
              marginTop: "1em", // Add spacing below the heading
            }}
          >
            Il prodotto è stato aggiunto con successo, puoi trovarlo nella tua Home.
          </Text>
        </View>

        {/* Section: Button */}
        <View
          style={{
            textAlign: "center",
            paddingTop: "1em",
          }}
        >
          <GeneralButton width="300px" text="Torna alla Home Page" url="/home/producer" />
        </View>
      </Grid>
    </div>
  );
};
